<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>lock</v-icon> CERRAR PLANILLA </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="px-2">
          <v-layout row wrap class="text-xs-center blue--text">
            <v-flex shrink style="font-size:1.2em"
              ><b> GESTIÓN:</b> {{ this.form.gestion }}
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink style="font-size:1.2em"
              ><b> MES:</b> {{ this.form.mes }}
            </v-flex>
            <v-flex xs12>
              <v-text-field
                class="text-field-reducido-border"
                v-model="form.justificacion"
                :rules="$validate(['required'])"
                required
                label="Justificación*"
                outline
                clearable
                success
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      valid: true,
      form: {},
      dialog: false,
      loading: false,
      user: this.$storage.get("user")
    };
  },
  mounted() {
    this.$bus.$on("openDialogCerrarPlanilla", item => {
      this.form = item;
      this.form.justificacion = "Cierre de planillas";
      this.dialog = true;
    });
  },
  methods: {
    // Metodo para cerrar la planilla
    async save() {
      try {
        if (!this.$refs.form.validate()) {
          return;
        }
        if (!this.form.gestion || !this.form.mes) {
          this.$message.info("Seleccione gestión y mes");
          return;
        }
        this.$confirm(
          "¿Está seguro de cerrar la planilla seleccionada?",
          async () => {
            this.loading = true;
            var query = `select planilla.fn_cierra_mes_planilla(${this.form.gestion},${this.form.mes},'${this.form.justificacion}',${this.user.id})`;
            let res = await this.$service.graphql({
              query: `
                query{
                  runQuery(consulta:"${query}"){
                    respuesta
                  }
                }
              `
            });
            if (res.runQuery.respuesta) {
              res = res.runQuery.respuesta[0].fn_cierra_mes_planilla.split("|");
              if (res[0] == "1") {
                this.$message.success(res[1]);
              } else {
                this.$message.error(res[1]);
              }
            }
            this.close();
            this.loading = false;
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.loading = false;
      this.dialog = false;
      this.$bus.$emit("closeDialogCerrarPlanilla");
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/admin/asistencia/dialogs/CerrarPlanilla.vue